document.addEventListener('DOMContentLoaded', () => {
  const checks = document.querySelectorAll('.js-cart-required-check')
  const checkoutButton = document.querySelector('button[name="checkout"], input[name="checkout"]')
  const modal = document.getElementById('cart-check-modal')
  const closeButton = document.getElementById('cart-check-modal-close')

  if (!checkoutButton || !modal) return

  closeButton?.addEventListener('click', () => {
    modal.hidden = true
  })

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.hidden = true
    }
  })

  const clearError = (check) => {
    check.closest('label')?.classList.remove('cart-check-error')
  }

  const showError = (check) => {
    check.closest('label')?.classList.add('cart-check-error')
  }

  checks.forEach(check => {
    check.addEventListener('change', () => {
      if (check.checked) {
        clearError(check)
      }
    })
  })

  checkoutButton.addEventListener('click', (event) => {
    const uncheckedChecks = [...checks].filter(check => !check.checked)

    if (uncheckedChecks.length > 0) {
      event.preventDefault()
      event.stopPropagation()

      // いったん全ての赤枠を消す
      checks.forEach(clearError)

      // 未チェック項目だけ赤枠にする
      uncheckedChecks.forEach(showError)

      // 最初の未チェック項目へスクロール
      uncheckedChecks[0].closest('label')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })

      modal.hidden = false
    }
  })
})